import type { Theme, LocalStoreInterface } from './types';

export class LocalStore implements LocalStoreInterface {

  get app(): string | undefined {
    return localStorage.getItem('local-app') ?? undefined;
  }

  set app(value: string | undefined) {
    if (value == null) {
      localStorage.removeItem('local-app');
      return;
    }
    localStorage.setItem('local-app', value);
  }

  get lang(): string {
    return localStorage.getItem('lang') ?? this.getBrowserLang();
  }

  set lang(value: string) {
    localStorage.setItem('lang', value);
  }

  get token(): string | undefined {
    return localStorage.getItem('local-access-token') ?? undefined;
  }

  set token(value: string | undefined) {
    if (value == null) {
      localStorage.removeItem('local-access-token');
      return;
    }
    localStorage.setItem('local-access-token', value);
  }

  get refreshToken(): string | undefined {
    return localStorage.getItem('local-refresh-token') ?? undefined;
  }

  set refreshToken(value: string | undefined) {
    if (value == null) {
      localStorage.removeItem('local-refresh-token');
      return;
    }
    localStorage.setItem('local-refresh-token', value);
  }

  get expireAt(): number | undefined {
    return localStorage.getItem('local-access-token-expireAt') == null
      ? undefined : Number(localStorage.getItem('local-access-token-expireAt'));
  }

  set expireAt(value: number | undefined) {
    if (value == null) {
      localStorage.removeItem('local-access-token-expireAt');
      return;
    }
    localStorage.setItem('local-access-token-expireAt', `${value}`);
  }

  get id(): string | undefined {
    return localStorage.getItem('local-login-id') ?? undefined;
  }

  set id(value: string | undefined) {
    if (value == null) {
      localStorage.removeItem('local-login-id');
      return;
    }
    localStorage.setItem('local-login-id', value);
  }

  get csrf(): string | undefined {
    return localStorage.getItem('local-access-token') ?? undefined;
  }

  set csrf(value: string | undefined) {
    if (value == null) {
      localStorage.removeItem('local-csrf');
      return;
    }
    localStorage.setItem('local-csrf', value);
  }

  get code(): string | undefined {
    return localStorage.getItem('local-login-code') ?? undefined;
  }

  set code(value: string | undefined) {
    if (value == null) {
      localStorage.removeItem('local-login-code');
      return;
    }
    localStorage.setItem('local-login-code', value);
  }

  get theme(): Theme {
    return (localStorage.getItem('local-theme') ?? 'light') as Theme;
  }

  set theme(value: Theme) {
    localStorage.setItem('local-theme', value);
  }

  private getBrowserLang(): string {
    const lang = navigator.language;
    if (/en/i.test(lang)) {
      return 'en';
    }
    if (/zh-cn/i.test(lang)) {
      return 'zh_cn';
    }
    if (/zh-(hk|tw)/i.test(lang)) {
      return 'zh_hk';
    }
    if (/ja/i.test(lang)) {
      return 'jp';
    }
    return 'zh_cn';
  }

}
